import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';


@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        var token = localStorage.getItem("authToken");
        if (token != '') {
            req = req.clone({
                url: req.url,
                setHeaders: {
                    Authorization: `${token}`
                }
            });
        }
       
        return next.handle(req);
    }
}
